import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

import DatepickerContainer from '../containers/datepicker-container';
import DomainSelectorContainer from '../../common/containers/domain-selector-container';
import DomainTypeSelectorContainer from '../../common/containers/domain-type-selector-container';
import ExportToPdfContainer from '../containers/export-to-pdf-container';
import Intervalpicker from '../../common/containers/intervalpicker-container';
import { reportOptions } from '../constants/reports';

const styles = theme => ( {
    flexBox: {
        backgroundColor: theme.palette.background.paper,
        flex: 1,
    },
    header: {
        height: 40
    },
    rightPickerWithPadding: {
        '&:first-of-type': {
            paddingRight: 0,
        },
        'float': 'right',
        paddingRight: theme.spacing.unit * 4,
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        padding: `${theme.spacing.unit * 2}px`,
        [theme.breakpoints.up( 'xl' )]: {
            marginLeft: 'auto',
            marginRight: 'auto',
            width: 1860,
        },
    },
    title: {
        'float': 'left'
    },
} );

export const ReportContent = (
    {
        classes,
        content,
        match: { params: { reportId } },
        header,
        selectedReport: { options }
    } ) => {

    return (
        <div className={classes.flexBox}>
            <div className={classes.root}>
                <Grid container justify="center" alignContent="center" className={`no-print ${classes.header}`}>
                    <Grid item xs={12}>
                        <Typography variant="h5" className={classes.title}>{header.title}</Typography>
                        {
                            options.includes( reportOptions.exportToPdf ) &&
                            ( <span className={classes.rightPickerWithPadding}>
                                <ExportToPdfContainer automationId="export-to-pdf-reports" />
                            </span> )
                        }
                        {
                            options.includes( reportOptions.domainTypeSelector ) &&
                            ( <span className={classes.rightPickerWithPadding}>
                                <DomainTypeSelectorContainer namespace="reports" />
                            </span> )
                        }
                        {
                            options.includes( reportOptions.domainSelector ) &&
                            ( <span className={classes.rightPickerWithPadding}>
                                <DomainSelectorContainer namespace="reports" />
                            </span> )
                        }
                        {
                            options.includes( reportOptions.intervalPicker ) &&
                            ( <span className={classes.rightPickerWithPadding}>
                                <Intervalpicker namespace="reports" />
                            </span> )
                        }
                        {
                            options.includes( reportOptions.datePicker ) &&
                            ( <span className={classes.rightPickerWithPadding}>
                                <DatepickerContainer namespace="reports" isDomainPortfolio={reportId === 'domain-portfolio'}/>
                            </span> )
                        }
                    </Grid>
                </Grid>
                {content}
            </div>
        </div>
    );
};

ReportContent.propTypes = {
    classes: PropTypes.object.isRequired,
    content: PropTypes.object,
    header: PropTypes.object,
    match: PropTypes.shape( {
        params: PropTypes.object,
        url: PropTypes.string
    } ),
    options: PropTypes.array,
    selectedReport: PropTypes.shape( {
        options: PropTypes.array,
    } ),
};

ReportContent.defaultProps = {
    selectedReport: {
        options: []
    }
};

export default withStyles( styles )( ReportContent );
